import React from "react";

import {styled} from "@mui/material/styles";

import {ReactComponent as ShoppingBag} from "assets/img/shoppingbag.svg";
const StyledSvg = styled(ShoppingBag)({
    width: '20px',
    height: '20px',
    'path': {
        stroke: 'currentColor'
    }
});

export default function CornersIcon(props) {
    return <StyledSvg {...props} />;
}
